import * as React from "react";

const CustomTickIcon: React.FC = () => {
    return (
        <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.025 0.260393L5.74986 10.5355L1.97439 6.76008C1.79135 6.57703 1.49455 6.57703 1.31146 6.76008L0.206621 7.86492C0.0235742 8.04797 0.0235742 8.34477 0.206621 8.52785L5.41838 13.7396C5.60143 13.9227 5.89822 13.9227 6.08131 13.7396L17.7928 2.02817C17.9758 1.84512 17.9758 1.54832 17.7928 1.36524L16.6879 0.260393C16.5049 0.0773462 16.2081 0.0773462 16.025 0.260393Z"
                fill="#474747"
            />
        </svg>
    );
};

export default React.memo(CustomTickIcon);
